import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import { ActionButton, PauseActionButton } from 'commerce-subscription-lib/public/components';
import { useSubscriptionActions } from 'commerce-subscription-lib/public/hooks';
import { SubscriptionActions } from 'commerce-subscription-lib/public/types';
import { useHasBillingWizardGate } from '../hooks/useHasGate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  Edit,
  UpdatePaymentMethod,
  Cancel,
  EditNextPaymentDate,
  EditNextBillingDate,
  Pause
} = SubscriptionActions;
export function SubscriptionSidebarActions() {
  const actions = useSubscriptionActions();
  const revalidate = async () => {
    await actions[Cancel].revalidate();
  };
  const hasBillingWizardGate = useHasBillingWizardGate();
  return /*#__PURE__*/_jsx(UIFlex, {
    justify: "end",
    children: /*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "transparent",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "subscriptions.Actions.label"
      }),
      "data-selenium-test": "subscription-sidebar-actions",
      "data-test-id": "subscription-sidebar-actions",
      onOpenStart: revalidate,
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(ActionButton, {
          "data-test-id": "edit-subscription-button",
          action: actions[Edit],
          actionType: Edit
        }), /*#__PURE__*/_jsx(ActionButton, {
          "data-test-id": "update-payment-method-button",
          action: actions[UpdatePaymentMethod],
          actionType: UpdatePaymentMethod
        }), /*#__PURE__*/_jsx(ActionButton, {
          "data-test-id": "edit-next-payment-date-button",
          action: hasBillingWizardGate ? actions[EditNextBillingDate] : actions[EditNextPaymentDate],
          actionType: hasBillingWizardGate ? EditNextBillingDate : EditNextPaymentDate
        }), /*#__PURE__*/_jsx(PauseActionButton, {
          action: actions[Pause],
          actionType: Pause
        }), /*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(ActionButton, {
          "data-test-id": "cancel-subscription-button",
          action: actions[Cancel],
          actionType: Cancel
        })]
      })
    })
  });
}